module.exports = __webpack_public_path__ + "static/footer3@3x-2047b96640fe4c348cbf1073ec4a6ecf.png";